import UpdateTicker from './components/UpdateTicker';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotRanking from './components/HotRanking';
import TopicWall from './components/TopicWall';
import FeatureCollection from './components/FeatureCollection';
import TimelineSection from './components/TimelineSection';
import EvidenceSection from './components/EvidenceSection';
import SubscribeCTA from './components/SubscribeCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <div className="fixed top-0 inset-x-0 z-50">
        <UpdateTicker />
        <Navbar />
      </div>

      <main className="pt-[100px]">
        <Hero />
        <HotRanking />
        <TopicWall />
        <FeatureCollection />
        <TimelineSection />
        <EvidenceSection />
        <SubscribeCTA />
      </main>

      <Footer />
    </div>
  );
}